<template>
    <div>
        <div :id="'product_card_'+product.code" class='card'>
            <a class='top-content product-link' :class="{ 'disabled-product-link': is_amend }" @click='productClick' :href="is_amend ? undefined  : `/p/${this.product.code}/${this.product.producturl}`">
                <DynamicImageContainer class="product-image" :image='product.main_picture' :image_on_hover='product.second_picture' :show_different_image_on_hover='false' />
                <div class='product-info'>
                    <div class='product-heading'>{{product.product}}</div>
                    <div>
                        <div v-if="product.mix_six_price > 0" class='price'>£{{parseFloat(product.mix_six_price).toFixed(2)}} <span class='mix-six-text' @mouseenter="showMixSixInfo(product)" @mouseleave="hideMixSixInfo(product)">Mix Six</span></div>
                        <div v-show='product.show_mix_six_info' class='mix-six-info-container'><p>Standard promotional price per bottle when buying any (minimum) 6 wines</p></div>
                    </div>
                    <div class='price per-bottle'><span class='lock-it-in-price'>£{{parseFloat(product.price).toFixed(2)}} LOCK IT IN</span> price per bottle</div>
                    <div><i class="fa-solid fa-plus"></i> More Details</div>
                    <DynamicImageContainer v-show='product.flag_image != ""' class="flag-image" :image='"flags/"+product.flag_image' :show_different_image_on_hover='false' />
                </div>
            </a>
            <div v-show='error_message != ""' class="error-message">
                {{ error_message }}
            </div>
            <div class='bottom-container'>
                <div class='quantity-container' v-if='this.product.total_stock != 0' >
                    <input class='quantity-text-box' type="text" id="quantity" name="quantity" v-model='quantity' @blur='blurQuantity'>
                    <div class='quantity-buttons-container'>
                        <div @click='incrementQuantity' class='change-quantity-button no-highlight'>+</div>
                        <div @click='decrementQuantity' class='change-quantity-button no-highlight'>-</div>
                    </div>
                </div>
                <div v-if='this.product.total_stock != 0'>
                    <Button class='lock-it-in-button' v-show='!product.locked_in' text='Lock it in' theme='green' @click='addItemToCart'/>
                    <Button class='lock-it-in-button' v-show='product.locked_in' text='Remove' disabled='true ' theme='dark' @click='removeItemFromCart'/>
                </div>
            </div>
        </div>

        <div :id='"page_number_"+product.page_number'></div>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue'
import {checkAuth, fireCartEvent, fireOmetriaBasketEvent} from "@/global/modules/functions.js";
import OutOfStockAlert from '@/ecom/components/cart/OutOfStockAlert.vue';
import NotifyWhenAvailableButton from '@/ecom/components/buttons/NotifyWhenAvailableButton.vue';
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components:{Button, OutOfStockAlert, NotifyWhenAvailableButton, DynamicImageContainer},
    emits: ['updatedCartListener', 'wishlistListener', 'cardClickedListener', 'addToCartListener', 'removedFromCartListener', 'openProductInfoModalListener'],
    props: ['product', 'page_builder_mode', 'total_cart_quantity', 'is_amend'],
    data(){
        return{
            quantity: 2,
            stock: {},
            cart_event: '',
            error_message: ''
        }
    },
    methods:{
        productClick(e){
            if (this.is_amend) {
                this.$emit('openProductInfoModalListener', this.product);
                e.preventDefault();
                e.stopImmediatePropagation();
                return;
            }

            if(e.ctrlKey) {
                return;
            }
            else {
                e.preventDefault();
                
                if(!this.page_builder_mode){
                    this.$emit('cardClickedListener');
                    this.$router.push(`/${this.product.category_url}${this.product.producturl}`);
                }
            }
        },
        addItemToCart() {
            this.cart_event = 'add_item_to_cart';
            this.addToCart();
        },
        async addToCart(){
            this.error_message = '';
            if(Number(this.quantity) < 2) {
                this.error_message = "Minimum quantity must be 2";
                return;
            }
            
            let response = await fetch(`/api/lock-it-in/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   quantity: this.quantity,
                   type: 'override_quantity',
                   is_amend: this.is_amend
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.stock = results.stock;
                this.$emit('updatedCartListener');
                this.$emit('addToCartListener', this.product, this.quantity);
                this.triggerCartEvent();
                fireOmetriaBasketEvent(results.cart, 'lock_it_in');
            }
        },
        async removeItemFromCart(){
            this.cart_event = 'remove_item_from_cart';
            let response = await fetch(`/api/lock-it-in/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   type: 'remove_item_from_cart',
                   is_amend: this.is_amend
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.$emit('updatedCartListener');
                this.$emit('removedFromCartListener', this.product, this.quantity);
                this.triggerCartEvent();
                fireOmetriaBasketEvent(results.cart, 'lock_it_in');
            }
        },

        blurQuantity(){
            if(isNaN(this.quantity) || this.quantity == ''){
                this.quantity = 2;
            }

            this.error_message = '';
            if(Number(this.quantity) < 2) {
                this.error_message = "Minimum quantity must be 2";
                return;
            }

            if(this.product.locked_in){
                this.cart_event = 'blur_quantity';
                this.addToCart();
            }
        },
        incrementQuantity(){
            this.quantity++;

            if(this.product.locked_in){
                this.cart_event = 'increment_quantity';
                this.addToCart();
            }
        },
        decrementQuantity(){
            if(this.quantity > 2){
                this.quantity--;
            }

            if(this.product.locked_in){
                this.cart_event = 'decrement_quantity';
                this.addToCart();
            }
        },
        triggerCartEvent() {
            let change_quantity = (this.cart_event == 'increment_quantity' || this.cart_event == 'decrement_quantity') ? 1 : this.quantity;
            let event_name      = (this.cart_event == 'decrement_quantity' || this.cart_event == 'remove_item_from_cart') ? 'remove_from_cart' : 'add_to_cart';
            fireCartEvent(this.product, change_quantity, event_name, 'lock-it-in');
        },
        showMixSixInfo(product){
            product.show_mix_six_info = true;
        },
        hideMixSixInfo(product){
            product.show_mix_six_info = false;
        }
    },
    mounted(){
        if(this.product.locked_in){
            this.quantity = this.product.cart_quantity ?? 2;
        }
    }
}
</script>

<style lang="scss" scoped>

.card{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: var(--product-card-width);
    // width: 100%;
    border: 1px solid var(--dark-grey);
    padding: 24px;
    box-sizing: border-box;
    color: var(--maj-slate);
    height: 305px;
    border-radius: 4px;
    

    @media(max-width: 1520px){
       width: 400px;
    }

    @media(max-width: 1150px){
        width: 300px;
        height: 400px;
    }

    @media(max-width: 936px){
        width: 500px;
        // height: 450px;
    }

    @media(max-width: 768px){
        width: 90vw;
        height: 360px;
    }
}

.top-content{
    display: flex;
    gap: 24px;
}

.product-info{
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-left: 5px;
    padding-right: 5px;
    text-decoration: none;
    color: #212529;
}

.product-link{
    text-decoration: none;
    color: #212529;
}

.disabled-product-link{
    // pointer-events: none;
    // cursor: default;
    cursor: pointer;
}

.product-heading{
    font-size: 1.2rem;
    font-weight: 500;
}

.product-image{
    width: 60px;
    height: 200px;
}

.flag-image{
    width: 30px;
    height: 30px;
}

.bottom-container{
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    height: 40px;
    justify-content: flex-end;
    gap: 16px;
}

.button{
    width: 100px;
}

.price{
    font-size: 0.96rem;
    font-weight: 600;
}

.price.per-bottle{
    margin-top: -8px;
}

.quantity-text-box{
    width: 40px;
    height: 38px;
    text-align: center;
    border-top: solid 1px #dee2e6;
    border-left: none;
    border-right: none;
    border: 1px solid #dee2e6;
    outline: none;
}

.lock-it-in-button{
    width: 160px;
}

.quantity-container{
    display: flex;
}

.change-quantity-button{
    border: 1px solid #dee2e6;
    height: 19px;
    width: 19px; 
    cursor: pointer;
}

.lock-it-in-price{
    font-weight: 700;
    font-size: 1.2rem;
}

.no-highlight {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}


.mix-six-text{
    border-bottom: dashed 1px #28353359;
}

.mix-six-info-container{
    position: absolute;
    padding: 20px;
    background-color: white;
    border: 1px #28353386 solid;
    border-radius: 8px;
}

.error-message {
    color: #e03131;
    font-size: 0.85rem;
    text-align: right;
    margin-right: 48px;
    margin-bottom: 5px;
}
</style>